<template>
    <div class="row">
        <div :style="!permissions.find(e => e.permission_name == 'View Delivery Charge') ? 'filter: blur(4px); pointer-events: none;' : ''" >
            <div class="col-12 col-xl-8">
                <div class="card card-body bg-white border-light shadow-sm mb-4">
                    <h2 class="h5 mb-4">General information  </h2>
                    <div class="row">
                        <!-- <div class="col-md-6 mb-3">
                            <MssInput v-model="form.linkname" placeholder="Enter Page Link" required></MssInput>
                        </div> -->
                        <div class="col-md-12 mb-3">
                            <MssInput :disabled="!permissions.find(e => e.permission_name == 'Update Delivery Charge')" type="number" v-model="min_amt_for_free" placeholder="Enter the minimum amount for free delivery" required></MssInput>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-xl-4 sidebar-stricky">
                <div class="card card-body bg-white border-light shadow-sm mb-4">
                    <div class="row">
                        <div class="col-md-12 mb-5">
                            <MssInput type="switch" v-model="free_delivery" placeholder="Free delivery to all orders"></MssInput>
                        </div>
                        <div class="col-md-12 mb-4">
                            <div>
                                <button :disabled="!permissions.find(e => e.permission_name == 'Update Delivery Charge')" class="btn btn-info btn-block" @click.prevent="saveData"><i class="fa fa-save mr-3"></i>SAVE</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="position: relative; margin-top: -20%; z-index: 1; width: max-content; left: 50%; transform: translate(-50%, 0%);" v-if="!permissions.find(e => e.permission_name == 'View Delivery Charge')">
            <span style="color: red;"><i class="mr-2 fa fa-eye-slash"></i>You dont have the viewing permission.</span>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2'
import axios from 'axios'
export default {
    data() {
        return {
            min_amt_for_free: null,
            free_delivery: false,
            permissions: null,
        }
    },
    async mounted() {
        if (localStorage.getItem('permissions')) {
            const permissionsLS = localStorage.getItem('permissions')
            const permission = JSON.parse(permissionsLS)
            this.permissions = permission.filter(e => e.section == 'DELIVERY CHARGES' && e.has_permission == true)
        }
        await this.fetchData() 
    },
    methods: {
        async saveData() {
            const data = {
                type: 'save_delivery_charge_offers',
                min_amt_for_free: this.min_amt_for_free,
                free_delivery: this.free_delivery,
            }
            const response = await axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                data: data
            })
            this.$swal({
                toast: true,
                position: 'top-end',
                timer: 5000,
                icon: response.data.status,
                timerProgressBar: true,
                title: response.data.msg
            })
            await this.fetchData()
        },
        async fetchData() {
            const response = await axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'updatedApiForProducts.php?type=fetch_delivery_charge_offers',
            })
            if (response.data.status == 'success') {
                this.min_amt_for_free = response.data.data.min_amt_for_free
                this.free_delivery = response.data.data.free_delivery
            }
        }
    }
}
</script>